import { Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmComponent } from '../../components/utils/confirm/confirm.component';

@Injectable()
export class ConfirmService {

  constructor(
    private modalService: NgbModal,
  ) { }

  confirm(titulo: string, contenido: string) {

    const promise = new Promise((resolve, reject) => {
      const viewModal = this.modalService.open(ConfirmComponent,  {windowClass: 'modal-admin'});
      viewModal.componentInstance.titulo = titulo;
      viewModal.componentInstance.contenido = contenido;

      viewModal.result
        .then((resp: boolean) => {
          resolve(resp);
        });
    });

    return promise;
  }

}



// WEBPACK FOOTER //
// /app/src/app/services/confirm/confirm.service.ts